module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=UZ - Uzbekistan.51c5c4ea.svg";